import { useQuery } from '@tanstack/react-query'

const { handleErrors, getHeaders } = require('services/api/utils')
const { findOutWhichEnv, getEnvPath } = require('utils/env')

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function getActivatedAccounts() {
  return fetch(`${BASE_PATH}/account`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

export const QUERY_ACTIVATED_ACCOUNTS_KEY = 'get-activated-accounts-list'

const useGetActivatedAccountsList = () => {
  return useQuery({
    queryKey: [QUERY_ACTIVATED_ACCOUNTS_KEY],
    queryFn: getActivatedAccounts,
    select: (response) => response.data,
    retry: 1,
    staleTime: 0,
    cacheTime: 0,
  })
}

export default useGetActivatedAccountsList
